export const setupCopyEs = {
    yourHospitalNumber: "Su número de historia clínica",
    hospitalNumberIntro:
        "Su número de historia clínica permite identificarle en el sistema del hospital. Si su médico le ha asignado un número, introdúzcalo aquí.",
    hospitalNumberFieldHint: "Permite identificarle en el sistema del hospital.",
    dontKnow: "No lo sé",
    skipForNow: "Aún no lo sé",
    whichSideAffectedTitle: "¿Qué lado de su cuerpo está afectado?",
    sideSetupLeadInTrackersOnly:
        "Necesitamos saber qué lado de su cuerpo está afectado para hacerle las preguntas adecuadas sobre los siguientes cuestionarios: ",
    sideSetupLeadInProceduresOnly: "Necesitamos saber qué lado de su cuerpo está afectado para hacerlo coincidir con: ",
    sideSetupLeadInBoth:
        "Necesitamos saber qué lado de su cuerpo está afectado para hacerle las preguntas adecuadas sobre los siguientes cuestionarios y su tratamiento: ",
    sideSetupBothSidesNote:
        "Si están afectados ambos lados, elija « Ambos » y añadiremos un cuestionario para cada lado.",
    saveDate: "Guardar la fecha",
    pickDate: "Elegir una fecha",
    clearDateAndTime: "Borrar fecha y hora",
    missingReferenceDateDataError:
        "No se ha podido guardar la fecha de la intervención - faltan identificadores de los datos. Actualice la página o contacte con el soporte si el problema continúa.",
    referenceDateMinMessage: "Elija una fecha de hace 2 años como máximo.",
    referenceDateMaxMessage: "Elija una fecha dentro de 2 años como máximo.",
    referenceDateQuestion: (kind) => {
        if (kind === "product") return "Inicio del tratamiento";
        if (kind === "injection") return "¿En qué fecha tuvo o tendrá la inyección?";
        if (kind === "surgery") return "¿En qué fecha tuvo o tendrá la cirugía?";
        if (kind === "medication") return "¿En qué fecha empezó o empezará el medicamento?";
        if (kind === "shockwave") return "¿En qué fecha empezó o empezará la terapia con ondas de choque?";
        if (kind === "consultation") return "¿En qué fecha tuvo o tendrá la consulta?";
        return "¿En qué fecha tuvo o tendrá la intervención?";
    },
    referenceDateDescriptionFor: (phrase, kind) => {
        if (kind === "product") {
            return `¿Cuándo empezó (o empezará) a usar ${phrase}? Indique la fecha de inicio de su tratamiento, pasada o futura. Esto nos permite hacerle las preguntas de seguimiento adecuadas.`;
        }
        if (kind === "injection") {
            return `Elija la fecha de su inyección - pasada o futura - para que las preguntas de seguimiento coincidan con ella.`;
        }
        if (kind === "shockwave") {
            return `Elija la fecha de su terapia con ondas de choque - pasada o futura - para que las preguntas de seguimiento coincidan con ella.`;
        }
        if (kind === "surgery") {
            return `Elija la fecha de su intervención (${phrase}) - pasada o futura - para que las preguntas de seguimiento coincidan con ella.`;
        }
        if (kind === "consultation") {
            return `Elija la fecha de su consulta - pasada o futura - para que las preguntas de seguimiento coincidan con ella.`;
        }
        return `Elija la fecha de su intervención (${phrase}) - pasada o futura - para que las preguntas de seguimiento coincidan con ella.`;
    },
    productStartDateLabel: (phrase) => `Inicio del tratamiento: ${phrase}`,
    chooseDateError: (phrase) => `Elija la fecha de su intervención (${phrase})`,
    chooseProductStartDateError: (phrase) => `Indique cuándo empezó a usar ${phrase}`,
    savedProcedureDateToast: (phrase) => `La fecha de su intervención (${phrase}) se ha guardado.`,
    savedProductStartDateToast: (phrase) => `La fecha de inicio de ${phrase} se ha guardado.`,
};
